import { RSAA } from 'redux-api-middleware';
import * as constants from './constants';
import * as reducersConstant from '../reducers';

const fetch_cb_country_details_by_id = id => ({
  [RSAA]: {
    endpoint: `/api/gis/countries/${id}?expand&cat`,
    method: 'GET',
    types: [
      constants.FETCH_CB_COUNTRY_DETAILS_REQUEST,
      constants.FETCH_CB_COUNTRY_DETAILS_SUCCESS,
      constants.FETCH_CB_COUNTRY_DETAILS_FAILURE
    ]
  }
});

export const fetch_country_details = () => {
  return async (dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: '/api/gis/countries/?search=Bangladesh',
        method: 'GET',
        types: [
          constants.CB_SEARCH_COUNTRY_REQUEST,
          constants.CB_SEARCH_COUNTRY_SUCCESS,
          constants.CB_SEARCH_COUNTRY_FAILURE
        ]
      }
    });

    if (actionResponse.error) {
      throw new Error('Promise flow received action error', actionResponse);
    }

    const country_id = actionResponse.payload.results[0].id;
    return await dispatch(fetch_cb_country_details_by_id(country_id));
  };
};

export const fetch_cb_cluster_details_by_id = id => ({
  [RSAA]: {
    endpoint: `/api/gis/cb_clusters/${id}?expand`,
    method: 'GET',
    types: [
      constants.FETCH_CB_CLUSTER_DETAILS_REQUEST,
      constants.FETCH_CB_CLUSTER_DETAILS_SUCCESS,
      constants.FETCH_CB_CLUSTER_DETAILS_FAILURE
    ]
  }
});

export const fetch_cb_area_details_by_id = id => ({
  [RSAA]: {
    endpoint: `/api/gis/cb_areas/${id}?expand`,
    method: 'GET',
    types: [
      constants.FETCH_CB_AREA_DETAILS_REQUEST,
      constants.FETCH_CB_AREA_DETAILS_SUCCESS,
      constants.FETCH_CB_AREA_DETAILS_FAILURE
    ]
  }
});

export const fetch_cb_thana_details_by_id = id => ({
  [RSAA]: {
    endpoint: `/api/gis/cb_thanas/${id}`,
    method: 'GET',
    types: [
      constants.FETCH_CB_THANA_DETAILS_REQUEST,
      constants.FETCH_CB_THANA_DETAILS_SUCCESS,
      constants.FETCH_CB_THANA_DETAILS_FAILURE
    ]
  }
});

export const change_filtering_state = (
  filteringState = constants.INIT_PARTNER_REPORTS_FILTER_STATE
) => ({
  type: constants.CHANGE_FILTERING_STATE,
  payload: filteringState
});

export const forward_fetch_by_selected_state = (id, selectedState) => {
  return async (dispatch, getState) => {
    switch (selectedState) {
      case reducersConstant.COUNTRY:
        dispatch(fetch_cb_cluster_details_by_id(id));
        break;
      case reducersConstant.CLUSTER:
        dispatch(fetch_cb_area_details_by_id(id));
        break;
      case reducersConstant.AREA:
        dispatch(fetch_cb_thana_details_by_id(id));
        break;
      default:
        break;
    }
  };
};

export const backward_fetch_by_selected_state = selectedState => {
  return async (dispatch, getState) => {
    const state = getState().user.cku.leftSidebar;
    let id = null;
    switch (selectedState) {
      case reducersConstant.CLUSTER:
        id = state.countryDetails.id;
        dispatch(fetch_cb_country_details_by_id(id));
        break;
      case reducersConstant.AREA:
        id = state.clusterDetails.id;
        dispatch(fetch_cb_cluster_details_by_id(id));
        break;
      case reducersConstant.THANA:
        id = state.areaDetails.id;
        dispatch(fetch_cb_area_details_by_id(id));
        break;
      default:
        break;
    }
  };
};
